import { LAYERS } from 'shared';
import { Tile as TileLayer } from 'ol/layer';
import TileWMS from 'ol/source/TileWMS';

export default class ProkatNDVILayer {
    map = null;
    layer = null;

    constructor(map) {
        this.map = map;
        this.init();
    }

    init() {
        this.layer = new TileLayer({
            title: 'NDVI',
            type: LAYERS.TYPES.PROKAT_NDVI,
            visible: false,
            displayInLayerSwitcher: true,
            source: new TileWMS({
                url: `/geoserver/wms?service=WMS`,
                crossOrigin: 'anonymous',
                params: {
                    LAYERS: 'PROKAT:HB_NDVI_2020M06',
                    FORMAT: 'image/png',
                },
            }),
        });
    }

    getLayer() {
        return this.layer;
    }

    update(layer) {}
}
